module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/151.d36ca961.png";